import { getCoverLevelOption, getCurrentQuote, isAuthenticated } from '../../../../domain'
import { getCoverLevelConfig } from '../../../../state/configuration'
import { CheckoutConfigContext } from './types'

export const always = () => true

export const isNotAuthenticated = ({ principal, policyholder }: CheckoutConfigContext) =>
  !isAuthenticated(policyholder, principal)

export const hasFinalMile = ({ product }: CheckoutConfigContext) =>
  Boolean(product.finalMile?.form?.length ?? false)

export const hasAddons = ({ product, proposal }: CheckoutConfigContext) => {
  const quote = getCurrentQuote(proposal)
  const coverLevelOption = getCoverLevelOption(quote)

  const { covers } = getCoverLevelConfig(product, coverLevelOption?.coverLevel) ?? {}

  return covers?.optional?.some((it) => !it.form) ?? false
}
